<template>
  <v-container grid-list-md fluid>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow justify-center align-center px-3 py-2"
    >
      <h3 class="flex xs12 md6 px-3 di-flex align-center">
        <span class="mx-1">{{ $t("transactions_report") }}</span>
      </h3>
      <v-spacer class="hidden-sm-and-down" />
      <v-autocomplete
        outline
        singleLine
        hideDetails
        autocomplete
        item-value="id"
        item-text="name"
        v-model="branch_id"
        :disabled="loading"
        :items="branch_filters"
        style="max-width: 300px"
        :placeholder="$t('branch')"
        v-if="userCan('view_all_branches_report')"
      />
      <v-autocomplete
        outline
        singleLine
        hideDetails
        autocomplete
        :disabled="loading"
        :items="reportTypes"
        v-model="report_type"
        style="max-width: 300px"
        :placeholder="$t('report')"
      />
    </v-layout>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow justify-center align-center px-3 py-2 mt-2"
    >
      <div class="px-3 align-center font-weight-bold filter-grid">
        <v-checkbox
          singleLine
          hideDetails
          class="mx-1"
          color="primary"
          v-model="trashed"
          :label="$t('deleted')"
          style="max-width: 120px"
        />
        <v-checkbox
          singleLine
          hideDetails
          class="mx-2"
          color="primary"
          v-model="auction"
          :label="$t('is_dab')"
          style="max-width: 170px"
          v-if="report_type == 'exchange'"
        />
        <v-checkbox
          singleLine
          hideDetails
          class="mx-2"
          color="primary"
          v-model="externals"
          :label="$t('externals')"
          style="max-width: 170px"
          v-if="
            report_type == 'exchange' ||
            report_type == 'receive' ||
            report_type == 'send'
          "
        />
        <v-checkbox
          singleLine
          hideDetails
          class="mx-2"
          color="primary"
          v-model="pep"
          :label="$t('pep')"
          style="max-width: 170px"
          v-if="
            report_type == 'exchange' ||
            report_type == 'receive' ||
            report_type == 'send'
          "
        />
        <v-checkbox
          singleLine
          hideDetails
          class="mx-2"
          color="primary"
          v-model="str"
          :label="$t('str')"
          style="max-width: 170px"
          v-if="
            report_type == 'exchange' ||
            report_type == 'receive' ||
            report_type == 'send'
          "
        />
        <v-checkbox
          singleLine
          hideDetails
          class="mx-2"
          color="primary"
          v-model="suction_checked"
          style="max-width: 270px"
          :label="$t('suction_checked')"
          v-if="
            report_type == 'exchange' ||
            report_type == 'receive' ||
            report_type == 'send'
          "
        />
      </div>
      <v-spacer></v-spacer>
    </v-layout>

    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white border justify-start align-center py-2 px-3"
    >
      <!-- <h3 class="px-3">MIN-MAX</h3>
      <v-text-field
        outline
        single-line
        hide-details
        data-vv-name="max"
        style="max-width: 250px"
        v-model="minimum_amount"
        :title="$t('minimum_amount')"
        v-currency="{ currency: null }"
        class="flex xs4 sm3 has_currency"
        :placeholder="$t('minimum_amount')"
      >
        <v-menu offset-y slot="append">
          <a
            slot="activator"
            class="mx-2 mt-2 font-weight-medium subheading align-center"
          >
            <span>{{ smbl(selected_currency_id) }}</span>
          </a>
          <v-list>
            <v-list-tile
              :key="index + 'se'"
              v-for="(item, index) in currencies"
              @click="selected_currency_id = item.id"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-text-field>
      <v-text-field
        outline
        clearable
        single-line
        hide-details
        data-vv-name="max"
        style="max-width: 250px"
        v-model="maximum_amount"
        :title="$t('maximum_amount')"
        v-currency="{ currency: null }"
        class="flex xs4 sm3 has_currency"
        :placeholder="$t('maximum_amount')"
      />-->
      <async-autocomplete
        outline
        autofocus
        clearable
        single-line
        hide-details
        item-value="id"
        url="/transfers/create"
        queries="external=true"
        @setItem="({})"
        v-model="customer_id"
        item-text="full_name"
        style="max-width: 43 0px"
        :placeholder="$t('customer')"
        :append-item="selectedCustomer"
        class="flex xs12 sm6 right-hint"
      >
        <template v-slot:item="{ item }">
          <v-list-tile-avatar>
            <img :src="item.image" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.full_name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ $t(item.type) }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </async-autocomplete>
      <v-spacer />
      <v-combobox
        outline
        clearable
        class="flex xs12 sm4"
        v-model="risk_categroy"
        :placeholder="$t('risk_profile')"
        :items="['High', 'Medium', 'Low']"
      />
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <credits
          ref="tbl"
          class="mt-3"
          :trashed="trashed"
          :reportView="true"
          :branch_id="branch_id"
          :customer_id="customer_id"
          :risk_category="risk_categroy"
          v-if="report_type == 'credit'"
          :brnch_name="selectedBranch.name"
          @customer_changed="customerChanged"
        />
        <debits
          ref="tbl"
          class="mt-3"
          :trashed="trashed"
          :reportView="true"
          :branch_id="branch_id"
          :customer_id="customer_id"
          :risk_category="risk_categroy"
          v-if="report_type == 'debit'"
          :brnch_name="selectedBranch.name"
          @customer_changed="customerChanged"
        />
        <exchanges
          ref="tbl"
          :pep="pep"
          :str="str"
          class="mt-3"
          :trashed="trashed"
          :auction="auction"
          :reportView="true"
          :externals="externals"
          :branch_id="branch_id"
          :customer_id="customer_id"
          :risk_category="risk_categroy"
          v-if="report_type == 'exchange'"
          :brnch_name="selectedBranch.name"
          :suction_checked="suction_checked"
          @customer_changed="customerChanged"
        />
        <expose-report
          ref="tbl"
          class="mt-3"
          :branch_id="branch_id"
          :customer_id="customer_id"
          :risk_category="risk_categroy"
          v-if="report_type == 'expose'"
          :brnch_name="selectedBranch.name"
          @customer_changed="customerChanged"
        />
        <exchange-income-report
          ref="tbl"
          class="mt-3"
          :branch_id="branch_id"
          :customer_id="customer_id"
          :risk_category="risk_categroy"
          :brnch_name="selectedBranch.name"
          v-if="report_type == 'exchangeIncome'"
          @customer_changed="customerChanged"
        />
        <send-transfers
          ref="tbl"
          :pep="pep"
          :str="str"
          class="mt-3"
          :trashed="trashed"
          :reportView="true"
          :externals="externals"
          :branch_id="branch_id"
          label="send_transfers"
          :customer_id="customer_id"
          v-if="report_type == 'send'"
          :risk_category="risk_categroy"
          :brnch_name="selectedBranch.name"
          :suction_checked="suction_checked"
          @customer_changed="customerChanged"
        />
        <receive-transfers
          ref="tbl"
          :pep="pep"
          :str="str"
          class="mt-3"
          :trashed="trashed"
          :reportView="true"
          :externals="externals"
          :branch_id="branch_id"
          :customer_id="customer_id"
          label="received_transfers"
          :risk_category="risk_categroy"
          v-if="report_type == 'receive'"
          :brnch_name="selectedBranch.name"
          :suction_checked="suction_checked"
          @customer_changed="customerChanged"
        />
        <a2a-transfers
          ref="tbl"
          class="mt-3"
          :trashed="trashed"
          :reportView="true"
          :branch_id="branch_id"
          label="a2a_transfers"
          :customer_id="customer_id"
          v-if="report_type == 'a2a'"
          :risk_category="risk_categroy"
          :brnch_name="selectedBranch.name"
          @customer_changed="customerChanged"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import debits from "@/views/roznamcha/tabs/debits";
import credits from "@/views/roznamcha/tabs/credits";
import exchanges from "@/views/roznamcha/tabs/exchanges";
import exposeReport from "@/views/reports/ExposeReport.vue";
import { exchange, customersMixin } from "@/mixins/index.js";
import a2aTransfers from "@/views/roznamcha/tabs/a2aTransfers";
import sendTransfers from "@/views/roznamcha/tabs/sendTransfers";
import receiveTransfers from "@/views/roznamcha/tabs/receiveTransfers";
import exchangeIncomeReport from "@/views/reports/exchangeIncomeReport.vue";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 1);
export default {
  name: "LCTR",
  mixins: [exchange, customersMixin],

  components: {
    debits,
    credits,
    exchanges,
    exposeReport,
    a2aTransfers,
    sendTransfers,
    receiveTransfers,
    exchangeIncomeReport,
  },

  data: () => ({
    pep: false,
    str: false,
    search: null,
    exchanges: [],
    transfers: [],
    currencies: [],
    loading: false,
    trashed: false,
    externals: false,
    auction: false,
    branch_filters: [],
    risk_categroy: null,
    branch_id: undefined,
    customer_id: undefined,
    report_type: "exchange",
    suction_checked: false,
    selected_currency: null,
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: currentDate.toLocaleDateString("en-ca"),
    selectedCustomer: false,
  }),
  computed: {
    customers: (vm) => vm.initialData.customers,
    reportTypes() {
      return [
        { text: this.$t("credits"), value: "credit" },
        { text: this.$t("debits"), value: "debit" },
        { text: this.$t("exchanges"), value: "exchange" },
        { text: this.$t("send_transfers"), value: "send" },
        { text: this.$t("received_transfers"), value: "receive" },
        { text: this.$t("a2a_transfers"), value: "a2a" },
        { text: this.$t("exchange_income_report"), value: "exchangeIncome" },
        { text: this.$t("expose_report"), value: "expose" },
      ];
    },
    branch() {
      return (
        this.$store.getters["AuthModule/current_user"]["branch"] || {
          id: undefined,
        }
      );
    },
    baseCurrency: (vm) => {
      let usd = 1;
      // currencies has rank also, works as currency
      return vm.currencies[usd] || { rank: 1, name: "" };
    },
    selectedBranch: (vm) =>
      vm.branch_filters.find((x) => x.id == vm.branch_id) || {},
  },

  methods: {
    customerChanged(id, customer) {
      this.customer_id = id;
      this.selectedCustomer = customer;
    },
    getFilteredItem(items, key) {
      if (this.search) {
        console.log(key);
        return items.filter((item) => {
          return ("" + item[key])
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
      return items;
    },

    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },
  },
  created() {
    this.branch_id = this.branch.id;
    this.getBranches();
  },
};
</script>
<style>
.filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
@media (max-width: 800px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 500px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }
}
</style>